<template>
  <div class="flex-column gap8">
    <label class="textBold"
      >{{ field.label }}
      <span
        v-if="isRequired"
        class="bold"
        style="color: var(--systemError)"
        >*</span
      ></label
    >

    <div
      class="question-container"
      :class="{ 'question-container-3cols': field.inputValues.length > 2 }"
    >
      <div
        v-for="(inputValue, index) in field.inputValues"
        :key="field.id + '-' + index"
        @click="toggleSelection(inputValue)"
      >
        <div
          v-if="inputValue.labelIcon"
          class="answer-tile"
          :class="{
            'answer-tile--active': selectedValues.includes(inputValue.value),
          }"
        >
          <FontAwesomeIcon
            :icon="inputValue.labelIcon"
            size="2x"
          />
          <div class="flex-row align-items-center grow">
            {{ inputValue.text }}
          </div>
        </div>

        <div v-else>
          <div
            class="answer-tile"
            :class="{
              'answer-tile--active': selectedValues.includes(inputValue.value),
            }"
          >
            <span class="checkmark" />
            <span>{{ inputValue.text }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useBnplApplicationStore } from "~/stores/bnplapplication";

const bnplApplicationStore = useBnplApplicationStore();

const selectedValues = ref([]);

const emit = defineEmits(["input"]);

const props = defineProps({
  field: {
    type: Object,
    required: true,
  },
  value: {
    type: Boolean,
    default: undefined,
  },
  isRequired: {
    type: Boolean,
    default: false,
    required: false,
  },
});

onMounted(() => {
  let alreadySelected = null;
  if (props.value !== undefined) {
    alreadySelected = props.value;
  } else {
    alreadySelected = bnplApplicationStore.getFlowQuestionAnswer(
      props.field.identifier
    );
  }
  if (alreadySelected) {
    selectedValues.value = JSON.parse(alreadySelected);
  } else {
    selectedValues.value = [];
  }
});

function saveData() {
  emit("input", JSON.stringify(selectedValues.value));
  /*
  bnplApplicationStore.saveDynamicData( {
    key: props.field.identifier,
    value: JSON.stringify(selectedValues.value),
  });
  */
}

function toggleSelection(inputValue) {
  const index = selectedValues.value.findIndex(
    (val) => val === inputValue.value
  );

  if (index > -1) {
    selectedValues.value.splice(index, 1);
  } else {
    selectedValues.value.push(inputValue.value);
  }

  saveData();
}
</script>

<style scoped>
.answer-tile {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  border: 1px solid white;
  text-align: center;
  background: white;
  border-radius: 8px;
  padding: 32px 16px;
  overflow: hidden;
  word-break: break-word;
  height: 100%;
  transition: all 0.1s;
}

.answer-tile--active {
  border-color: var(--systemSuccess);
  font-weight: 700;
  color: var(--brandPrimary);
}

.answer-tile--active > .checkmark {
  border-color: var(--brandPrimary);
  display: block;
  background-color: var(--brandPrimary);
}

.answer-tile input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  display: block;
  height: 24px;
  width: 24px;
  border: 2px solid var(--gray400);
  border-radius: 50%;
}

.question-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 8px 24px;
}

.question-container-3cols {
  grid-template-columns: repeat(3, 1fr);
}

@media only screen and (max-width: 792px) {
  .question-container-3cols {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
